import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'Home',
        name: 'Home',
        component: () => import('@/views/Home/index.vue')
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('@/views/About/index.vue'),
        meta: { fromDetailPage: false, keepAlive: true }
      },
      {
        path: 'arete',
        name: 'Arete',
        component: () => import('@/views/Arete/index.vue')
      },
      {
        path: 'info',
        name: 'Info',
        component: () => import('@/views/Info/index.vue')
      },
      {
        path: 'news',
        name: 'News',
        component: () => import('@/views/News/index.vue'),
        meta: { fromDetailPage: false, keepAlive: true }
      },
      {
        path: 'projects',
        name: 'Projects',
        component: () => import('@/views/Projects/index.vue'),
        meta: { fromDetailPage: false }
      },
      {
        path: 'news-detail',
        name: 'NewsDetail',
        component: () => import('@/views/NewsDetail/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
